import React, { Component, Fragment } from "react";
import Form from "@common/externos/components/validation/form.validation";
import { Row, Col } from "react-bootstrap";
import SuggestionSolicitarDocumento from "../components/solicitarDocumento.suggestion";
import { connect } from "@common/components/base.component";
import DataGridSolicitacao from "../container/solicitarDocumento.grid";
import autoBind from "react-autobind";
import solicitarDocumentoSelector from "../store/solicitarDocumento.selectors";
import solicitarDocumentoActions from "../store/solicitarDocumento.actions";
import RedeSIMHeader from "../../redeSIM.header";
import Card from "@common/externos/components/card/card.externo";
import { ddados } from "../solicitarDocumento.ddados";
import DDadosItem from "@common/components/ddados/ddados.item";
import Panel from "@common/externos/components/panel/panel.component";

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {}

  onCancel() {
    this.props.solicitarDocumentoActions.resetSolicitacaoDocumentoPost();
  }

  onSubmit(values) {
    this.props.solicitarDocumentoActions.postSolicitacaoDocumento(values);
  }

  onChange(values){
    this.props.solicitarDocumentoActions.mergeSolicitacaoDocumentoPost(values);
  }

  get buttonAssociar() {
    return [
      {
        title: "Associar",
        onClick: (values) => {
          return (e) => {
            this.props.solicitarDocumentoActions.validaGridSolicitarDocumento({
              ...values,
            });
          };
        },
        route: "solicitarDocumento.associar",
        url: "",
        icon: "fas fa-link",
      },
    ];
  }

  render() {
    const { title, solicitarDocumentoSelector } = this.props;
    const { solicitarDocumento } = solicitarDocumentoSelector;
    const { HeaderDocumento } = solicitarDocumento;
    const { Titulo, Campos } = ddados;

    return (
      <Fragment>
        <h2 className={"mb-4 mt-2"}>{Titulo}</h2>
        <RedeSIMHeader selector={HeaderDocumento} />
        <Card>
          <Form
            onCancel={this.onCancel}
            onSubmit={this.onSubmit}
            title={title}
            isView={true}
          >
            <Fragment>
              <Panel title="Email" expanded={true} expandedFix={true}>
                <Row>
                  <Col lg={12}>
                    <DDadosItem
                      name="EmailSolicitante"
                      {...Campos.EmailSolicitante}
                      state={solicitarDocumento.SolicitacaoDocumentoPost}
                      onBlur={(e)=>this.onChange({EmailSolicitante:e})}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={12}>
                    <DDadosItem
                      name="EmailEmpresa"
                      {...Campos.EmailEmpresa}
                      state={solicitarDocumento.SolicitacaoDocumentoPost}
                      onBlur={(e)=>this.onChange({EmailEmpresa:e})}
                    />
                  </Col>
                </Row>
              </Panel>
              <Panel title="Documento" expanded={true} expandedFix={true}>
                <Row>
                  <Col lg="6">
                    <SuggestionSolicitarDocumento
                      state={solicitarDocumento}
                      onChange={(value) =>
                        this.props.solicitarDocumentoActions.setSuggestionDocumento(
                          value
                        )
                      }
                      buttons={this.buttonAssociar}
                    />
                  </Col>
                </Row>
                <div className={"mt-3"}>
                  <Row>
                    <Col>
                      <DataGridSolicitacao />
                    </Col>
                  </Row>
                </div>
              </Panel>
            </Fragment>
          </Form>
        </Card>
      </Fragment>
    );
  }
}

export default connect({
  actions: {
    solicitarDocumentoActions,
  },
  selectors: {
    solicitarDocumentoSelector,
  },
})(Container);
